import { render, staticRenderFns } from "./cookie.vue?vue&type=template&id=2dbc289f&scoped=true&"
import script from "./cookie.vue?vue&type=script&lang=js&"
export * from "./cookie.vue?vue&type=script&lang=js&"
import style0 from "./cookie.vue?vue&type=style&index=0&lang=css&"
import style1 from "./cookie.vue?vue&type=style&index=1&id=2dbc289f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbc289f",
  null
  
)

export default component.exports